<!-- 初始化默认值配置组件 -->
<template>
  <el-popover
    placement="bottom"
    class="default-value-config"
    popper-class="default-value-config-popover"
    v-model="isShow"
    :offset="100"
    :width="_config.width || 310"
    :trigger="_config.trigger || 'click'"
  >
    <div class="default-value-config__content">
      <p class="default-value-config__content__top">
        请设置初始化默认值
        <span>
          <el-button 
            v-if="_config.trigger === 'manual'"
            size="mini" 
            :disabled="!isShow"
            @click="() => isShow = false"
          >
            取消
          </el-button>
          <el-button 
            size="mini" 
            type="primary" 
            :loading="saveLoading"
            :disabled="!isShow"
            @click="handleSave"
          >
            保存
          </el-button>
        </span>
      </p>
      <!-- 少数处理方式 -->
      <template v-if="_config.key === 'lack_handle_type'">
        <!-- 选项 -->
        <BaseRadioGroup v-model="val" class="default-value-config__content__options">
            <el-radio 
              border 
              v-for="item in options"
              :key="item.value" 
              :label="item.value"
              @click.native.prevent="handleLackHandleTypeChange(item.value)"
            >
              {{ item.label }}
            </el-radio>
        </BaseRadioGroup>
        <!-- 少数默认补料配置 -->
        <div v-if="val == 2" class="default-value-config__lackHandleType">
          <i class="default-value-config__lackHandleType__linker"></i>
          <div class="default-value-config__lackHandleType__content">
            <span>
              {{ lackHandleText }}
            </span>
            <BaseTextButton @click="handleOpenLackHandleTypeDialog">修改</BaseTextButton>
          </div>
        </div>
        <!-- 少数默认补料弹框 -->
        <LackHandleTypeDialog 
          ref="lackHandleTypeDialogRef" 
          pageSource="defaultValueConfig"
          @confirm="handleLackHandleTypeConfirm"
        />
      </template>

      <!-- 选项 -->
      <BaseRadioGroup v-else v-model="val" class="default-value-config__content__options">
        <template v-for="item in options">
          <el-radio 
            v-if="typeof item === 'object'" 
            border 
            :key="item.value" 
            :label="item.value"
          >
            <ColorBlock v-if="_config.key === 'color'" :color="item.value" />
            {{ item.label }}
          </el-radio>
          <el-radio 
            v-else 
            border 
            :key="item" 
            :label="item"
          >{{ item }}</el-radio>
        </template>
      </BaseRadioGroup>
      <div class="default-value-config__content__bottom">
        <BaseRadioGroup v-model="val">
          <el-radio v-if="!_config.hideNoneOption" border label="none">
            不选任何选项
          </el-radio>
          <el-radio border label="default">
            系统默认初始化选项
          </el-radio>
        </BaseRadioGroup>
      </div>
    </div>
    <span
      slot="reference" 
      class="default-value-config__icon" 
      @click="handleReferenceClick"
    > 
      <slot name="icon">
        <img :src="require('@@/assets/img/icons/icon_setting.png')"  />
      </slot>
    </span>
  </el-popover>
</template>

<script>
import { mapGetters } from 'vuex'

import { FR4_FIELDS } from '@@/utils/constant'
import { getNumberOptionKeys } from '@@/utils/getFields'
// 阻焊颜色色块
import ColorBlock from '@@/components/colorBlock/index'
// 少数默认补料弹框
import LackHandleTypeDialog, { getLackHandleText } from '@@/views/pcb/components/lackHandleTypeDialog'

export default {
  props: {
    /**
     * String：字段的key
     * 
     * Object：
     * {
     *  key: 字段的key
     *  value: 默认选中的值
     *  hideNoneOption: 隐藏 不选任何选项
     *  width: 宽度
     *  trigger: 弹框触发方式
     * }
     */
    config: {
      type: [String, Object]
    }
  },
  components: {
    ColorBlock,
    LackHandleTypeDialog
  },
  data() {
    return {
      isShow: false,
      saveLoading: false,
      val: '',
      lackHandleVal: { // 少数处理方式相关参数
        lack_handle_number_type: '', // 少数订单数量 1-按百分比 2-按订单数 3-完全不接受少数
        lack_handle_number: '', // 少数占比大于(按百分比时小数，其余整数)
        lack_handle_number_unit: '', // 少数补料数量单位： 1-% 2-pcs 3-set
        lack_handle_shipping_type: '', // 少数发货类型 1-和订单一起发货 2-少数单独发货
      },
    }
  },
  computed: {
    ...mapGetters('defaultValueConfig', [
      'pcbDefaultValue',
    ]),
    _config() {
      const config = this.config
      return typeof config === 'object' ? { ...config } : { key: config }
    },
    // 选项
    options() {
      const key = this._config.key
      // 阻焊颜色
      if (key === 'color') {
        return FR4_FIELDS[key].options.filter(item => !['哑光绿油', '哑光蓝油'].includes(item.value))
      }
      return FR4_FIELDS[key].options
    },
    // 少数处理方式文案
    lackHandleText() {
      const { val, lackHandleVal } = this
      if (val != 2) return ''
      return getLackHandleText(lackHandleVal)
    },
  },
  watch: {
    '_config.value'(newVal) {
      if (newVal) {
        this.val = newVal
      }
    },
    pcbDefaultValue(newVal) {
      const numberFields = getNumberOptionKeys('FR-4')
      const { key, value } = this._config
      const val = (newVal || {})[key]
      if (val) {
        this.val = numberFields.includes(key) && !['none', 'default'].includes(val) ? Number(val) : val
      } else {
        this.val = value || ''
      }

      // 填充少数默认补料参数
      if (key === 'lack_handle_type' && newVal.lack_handle_type == 2) {
        Object.keys(this.lackHandleVal).forEach(key => {
          this.lackHandleVal[key] = newVal[key] ? +newVal[key] : ''
        })
      }
    }
  },
  methods: {
    // 手动显示
    handleReferenceClick() {
      if (this._config.trigger === 'manual') {
        this.isShow = !this.isShow
      }
    },
    async handleSave() {
      const { val, _config } = this
      if (!val && val !== 0) return this.$message.error('请选择选项')

      let params = { [_config.key]: val }
      // 少数处理方式参数
      if (_config.key === 'lack_handle_type') {
        const lackHandleVal = this.lackHandleVal
        params = Object.entries(lackHandleVal).reduce((data, [key, value]) => {
          data[key] = val == 2 ? value : ''
          return data
        }, { lack_handle_type: val })
      }
      
      this.saveLoading = true
      await this.$store.dispatch('defaultValueConfig/setPcbDefaultValueConfig', params)
      this.saveLoading = false
      this.isShow = false
    },

    // 少数处理方式切换
    handleLackHandleTypeChange(lack_handle_type) {
      if (this.val === lack_handle_type) return
      // 当选择 少数默认补料，且没设置相关参数时显示弹框，否则直接选择
      if (lack_handle_type === 2 && !this.lackHandleVal.lack_handle_number_type) {
        this.handleOpenLackHandleTypeDialog()
      } else {
        this.val = lack_handle_type
      }
    },
    // 显示少数处理方式弹框
    handleOpenLackHandleTypeDialog() {
      this.$refs.lackHandleTypeDialogRef.open({ ...this.lackHandleVal })
    },
    // 少数处理方式弹框确认
    handleLackHandleTypeConfirm(data) {
      this.val = 2
      this.lackHandleVal = Object.assign(this.lackHandleVal, { ...data })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@@/styles/mixin.scss';

.default-value-config {
  .default-value-config__icon {
    display: flex;
    align-items: center;
    margin-right: 4px;
    font-size: 14px;
    cursor: pointer;
    >img {
      display: inline-block;
      width: 14px;
      height: 14px;
    }
  }
}
.default-value-config__content {
  .default-value-config__content__top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    font-size: 14px;
    .el-button {
      padding: 5px 10px;
      &.el-button--default:hover {
        color: $--form-color-base;
        border-color: $--form-color-base;
        background-color: #fff;
      }
      &.el-button--primary {
        background-color: $--form-color-base;
      }
    }
  }
  .default-value-config__content__options {
    .el-radio.is-bordered {
      margin-left: 0;
      margin-right: 10px;
      margin-bottom: 10px;
      &:last-child {
        margin-right: 0;
      }
    }
  }
  .default-value-config__content__bottom {
    .base-radio-group ::v-deep {
      display: flex;
      .el-radio {
        &:last-child {
          flex: 1;
          text-align: center;
        }
        .el-radio__input {
          display: inline-block;
          &.is-checked .el-radio__inner {
            border-color: $--form-color-base;
            background-color: #fff;
            &::after {
              width: 7px;
              height: 7px;
              background-color: $--form-color-base;
            }
          }
        }
      }
    }
  }
}

// 少数处理方式
.default-value-config__lackHandleType {
  box-sizing: border-box;
  position: relative;
  margin-bottom: 10px;
  padding: 4px 12px;
  width: 100%;
  border-radius: 3px;
  background-color: $--background-hover;
  .default-value-config__lackHandleType__linker {
    @include moduleLinkerMixin(18px, vertical, dark);
    position: absolute;
    top: -14px;
    left: 206px;
  }
  .default-value-config__lackHandleType__content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .base-text-button.el-button {
      background-color: #fff;
      &:hover {
        border-color: $--form-color-base;
        background-color: #fff;
      }
    }
  }
}
</style>